'use client';

import React from 'react';

/**
 * Componente AccountSourceToggle
 *
 * Toggle de fuente de datos activa, renderizado debajo del selector de cuentas.
 * Es puramente presentacional y genérico: las fuentes las define el proyecto
 * consumidor (ids, etiquetas y tono del punto de color) y el cambio se notifica
 * por `onSourceChange`.
 *
 * A propósito NO incluye analítica ni persistencia: eso es responsabilidad del
 * proyecto, igual que en el selector de cuentas.
 */
const AccountSourceToggle = ({
  sources = [],
  activeSourceId = null,
  onSourceChange = null,
  t = (key, fallback) => fallback || key,
  className = '',
}) => {
  const safeSources = Array.isArray(sources) ? sources : [];

  // Con menos de dos fuentes el toggle no aporta nada
  if (safeSources.length < 2) return null;

  const handleClick = (sourceId) => {
    // Click en la fuente ya activa es un no-op (no se notifica)
    if (sourceId === activeSourceId) return;
    onSourceChange?.(sourceId);
  };

  return (
    <fieldset
      className={`sidenav-account-source ${className}`.trim()}
      aria-label={t('account.source', 'Active data source')}
    >
      {safeSources.map((source) => {
        const isActive = source.id === activeSourceId;

        const buttonClasses = [
          'sidenav-account-source-option',
          isActive ? 'sidenav-account-source-option--active' : '',
        ]
          .filter(Boolean)
          .join(' ');

        const dotClasses = [
          'sidenav-account-source-dot',
          source.tone ? `sidenav-account-source-dot--${source.tone}` : '',
        ]
          .filter(Boolean)
          .join(' ');

        return (
          <button
            key={source.id}
            type="button"
            className={buttonClasses}
            aria-pressed={isActive}
            onClick={() => handleClick(source.id)}
          >
            <span className={dotClasses} aria-hidden="true" />
            {source.label}
          </button>
        );
      })}
    </fieldset>
  );
};

export default AccountSourceToggle;
